<div class="footer">
  <div class="wrapper">
    <div class="superior">
      <ul>
        <li>
          <h3>Contáctanos:</h3>
        </li>
        <li class="link">
          <a href="javascript:void(0);">
            600 337 8000
          </a>
        </li>
        <li class="link">
          <a href="javascript:void(0);">
            Metrogas.cl
          </a>
        </li>
      </ul>
      <ul>
        <li>
          <h3>Sigamos conectados:</h3>
        </li>
        <li>
          <ul class="rrss">
            <li>
              <a href="https://www.facebook.com/MetrogasCL/" target="_blank">
                <img src="./assets/img/fb.png" alt="Facebook Metrogas" />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/metrogas_cl/" target="_blank">
                <img src="./assets/img/in.png" alt="instagram Metrogas" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/metrogaschile" target="_blank">
                <img src="./assets/img/X.png" alt="Twitter Metrogas" />
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/user/MetrogasChile" target="_blank">
                <img src="./assets/img/yt.png" alt="Youtube Metrogas" />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/metrogaschile/" target="_blank">
                <img src="./assets/img/linkedin.png" alt="Youtube Metrogas" />
              </a>
            </li>
          </ul>
        </li>
      </ul>
      <ul>
        <li>
          <h3>Nuestros reconocimientos</h3>
        </li>
        <li>
          <img src="./assets/img/reconocimientos.png" alt="Nuestros reconocimientos" />
        </li>
      </ul>
    </div>
    <div class="inferior">
      <h3 class="txt-sucursales">Sucursales</h3>
      <p class="mensaje">
        <!--Oficinas Atención a Clientes Santiago y Rancagua abiertas de lunes a viernes de 10 a 14 horas. Oficinas de Osorno y Puerto Montt permanecen cerradas.<br>-->
        Recuerda que en caso de una emergencia relacionada con el suministro de gas natural, siempre llámanos al 600 337 8000 opción 1.
      </p>
      <div class="box-inferior">
        <ul>
          <li>
            <h3>Santiago</h3>
          </li>
          <li>
            <p>
              El Regidor 54, Las Condes.<br/>
              (a pasos del metro El Golf)<br/>
              Lunes a Viernes de 08:30 a 13 horas<br/>
              Excepto festivos.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <h3>Rancagua y Machalí</h3>
          </li>
          <li>
            <p>
              Pedro de Valdivia 100, Rancagua<br/>
              Lunes a viernes de 09 a 14 horas.<br/>
              Excepto festivos.
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <h3>Osorno:</h3>
          </li>
          <li>
            <p>
              Francisco Bilbao 1176, Osorno<br/>
              Lunes a viernes de 09 a 14 horas.<br/>
              Excepto festivos.<br/>
              <!--OFICINA CERRADA POR CONTINGENCIA COVID-->
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <h3>Puerto Montt</h3>
          </li>
          <li>
            <p>
              Benavente 867, Puerto Montt<br/>
              Lunes a viernes de 09 a 14 horas.<br/>
              Excepto festivos.<br/>
              <!--OFICINA CERRADA POR CONTINGENCIA COVID-->
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
